(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      // Hedgeroe (5 Oct 2026): drop other colours of this piece, anything already in
      // "Complete the look", and keep the first four.
      // Same "range" rule as snippets/hr-family.liquid: first two words, skipping size words.
      var stop = ',set,of,a,the,large,small,medium,mini,big,pair,1,2,3,4,5,6,';
      var family = function(t) {
        var words = (t || '').toLowerCase().replace(/\//g, ' ').replace(/ - /g, ' ').replace(/,/g, ' ').split(' ');
        var out = [];
        for (var i = 0; i < words.length && out.length < 2; i++) {
          if (!words[i] || stop.indexOf(',' + words[i] + ',') > -1) { continue; }
          out.push(words[i]);
        }
        return out.join(' ');
      };
      var srcId = productRecommendationsSection.dataset.sourceId;
      var srcFamily = productRecommendationsSection.dataset.sourceFamily;
      var show = parseInt(productRecommendationsSection.dataset.show, 10) || 4;
      var ctlIds = {};
      document.querySelectorAll('.hr-ctl .product-block[data-product-id]').forEach(function(b) {
        ctlIds[b.getAttribute('data-product-id')] = true;
      });
      var kept = 0;
      productRecommendationsSection.querySelectorAll('.product-list > .product-block[data-product-id]').forEach(function(b) {
        var id = b.getAttribute('data-product-id');
        var titleEl = b.querySelector('.product-block__title');
        var fam = family(titleEl ? titleEl.textContent : '');
        if (id === srcId || ctlIds[id] || (srcFamily && fam === srcFamily) || kept >= show) {
          b.parentNode.removeChild(b);
        } else {
          kept++;
        }
      });
      if (kept === 0) {
        productRecommendationsSection.innerHTML = '';
        return;
      }

      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
